module.exports = __webpack_public_path__ + "img/github.38447589.svg";